import React from 'react';
import { Form } from 'react-bootstrap';

const OthersEditor = ({
    data,
    profileContent,
    activeProfile,
    activeReportType,
    onUpdateContent
}) => {
    // Update a field in the "others" section
    const updateField = (fieldName, value) => {
        const safeProfileContent = profileContent || {};
        const safeProfile = safeProfileContent[activeProfile] || {};
        const safeReportType = safeProfile[activeReportType] || {};

        const updatedContent = {
            ...safeProfileContent,
            [activeProfile]: {
                ...safeProfile,
                [activeReportType]: {
                    ...safeReportType,
                    [fieldName]: value
                }
            }
        };
        onUpdateContent(updatedContent);
    };

    return (
        <div className="pfc-others-editor">
            <div className="pfc-form-group">
                <label htmlFor="others-href" className="pfc-label">Href (Link)</label>
                <Form.Control
                    id="others-href"
                    type="url"
                    className="pfc-input"
                    placeholder="Enter href link..."
                    value={data?.href || ''}
                    onChange={(e) => updateField('href', e.target.value)}
                />
                <small className="pfc-hint">External link for this profile</small>
            </div>

            <div className="pfc-form-group">
                <label htmlFor="others-recommendation" className="pfc-label">Recommendations</label>
                <Form.Control
                    id="others-recommendation"
                    as="textarea"
                    rows={3}
                    className="pfc-textarea"
                    placeholder="Enter recommendations..."
                    value={data?.recommendation || ''}
                    onChange={(e) => updateField('recommendation', e.target.value)}
                />
            </div>

            <div className="pfc-form-group">
                <label htmlFor="others-concern-area" className="pfc-label">Concern Areas</label>
                <Form.Control
                    id="others-concern-area"
                    as="textarea"
                    rows={3}
                    className="pfc-textarea"
                    placeholder="Enter concern areas..."
                    value={data?.concernArea || ''}
                    onChange={(e) => updateField('concernArea', e.target.value)}
                />
            </div>
        </div>
    );
};

export default OthersEditor;
